import PageShell from '@/components/feature/PageShell';
import Eyebrow from '@/components/base/Eyebrow';
import ContactForm from './components/ContactForm';

const faqs = [
  { q: 'What organisations do you work with?', a: 'We partner with founder-led businesses, growing companies and established organisations navigating change — typically where people decisions carry real weight for the future of the business.' },
  { q: 'Can I enquire about career opportunities?', a: 'Yes. Choose “Career Enquiry” in the form and tell us a little about your background and what you are exploring. We will let you know whether we can help.' },
  { q: 'What happens after submitting an enquiry?', a: 'A member of our team reads every enquiry personally. If there is a good fit, we will reach out to arrange an initial conversation to understand your needs in more detail.' },
];

export default function Contact() {
  return (
    <PageShell
      title="Contact | Start a Conversation | Morrow People"
      description="Get in touch with Morrow People about talent acquisition, HR advisory, people and organisation support or career guidance. Tell us what is on your mind."
    >
      <section className="bg-white pt-12 md:pt-20 pb-20 md:pb-28">
        <div className="wrap">
          <div className="mx-auto max-w-[1280px] grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-10">
            <div className="lg:col-span-5">
              <Eyebrow>LET&apos;S TALK</Eyebrow>
              <h1 className="mt-6 md:mt-8 font-display font-normal text-[clamp(2.25rem,4.4vw,3.75rem)] leading-[1.08] tracking-[-0.015em] text-foreground-950">
                Tell us what&apos;s on your mind.
              </h1>
              <p className="mt-6 md:mt-8 text-[16px] md:text-[17px] leading-[1.65] text-foreground-800 max-w-[440px]">
                Whether you&apos;re looking for the right people, navigating organisational change, or exploring your next step, we&apos;re here to listen.
              </p>
              <div className="mt-10 pt-6 border-t border-foreground-950/15 max-w-[440px] space-y-3 text-[15px] leading-[1.6] text-foreground-700">
                <p>Share a few details about your situation. A member of our team reads every enquiry personally.</p>
                <p>If there is a good fit, we&apos;ll be in touch to arrange an initial conversation.</p>
              </div>
            </div>
            <div className="lg:col-span-6 lg:col-start-7">
              <ContactForm />
            </div>
          </div>
        </div>
      </section>

      <section className="bg-background-50 py-20 md:py-24">
        <div className="wrap">
          <div className="mx-auto max-w-[1280px] grid grid-cols-1 lg:grid-cols-12 gap-10">
            <div data-reveal className="lg:col-span-5">
              <Eyebrow>GOOD TO KNOW</Eyebrow>
              <h2 className="mt-6 font-display font-normal text-[clamp(1.75rem,2.8vw,2.5rem)] leading-[1.1] text-foreground-950">Questions, answered.</h2>
            </div>
            <div data-reveal-stagger className="lg:col-span-6 lg:col-start-7 border-t border-foreground-950/15">
              {faqs.map((f) => (
                <details key={f.q} className="group border-b border-foreground-950/15 py-5">
                  <summary className="flex items-center justify-between gap-6 cursor-pointer list-none">
                    <h3 className="font-heading text-[19px] md:text-[21px] leading-snug text-foreground-950">{f.q}</h3>
                    <span className="w-8 h-8 flex items-center justify-center shrink-0 text-lg text-accent-600 transition-transform group-open:rotate-45">
                      <i className="ri-add-line"></i>
                    </span>
                  </summary>
                  <p className="mt-3 max-w-xl text-[15px] leading-[1.65] text-foreground-700">{f.a}</p>
                </details>
              ))}
            </div>
          </div>
        </div>
      </section>
    </PageShell>
  );
}